module.exports = __webpack_public_path__ + "img/pc4.0877ad9f.png";